import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { Company } from 'app/models/company.model';
import { Envanter } from 'app/models/envanter.model';
import { User } from 'app/models/user.model';
import { CompanyService } from 'app/services/company.service';
import { EnvanterService } from 'app/services/envanter.service';
import { ToasterService } from 'app/services/user-interaction/services/toaster.service';
import { BaseFormComponent } from '../../base-form.component';

@Component({
    selector: 'app-envanter-form',
    templateUrl: './envanter-form.component.html',
    styleUrls: ['./envanter-form.component.scss']
})
export class EnvanterFormComponent extends BaseFormComponent implements OnInit {


    public fileData: File[] = []
    public companyId:number;

    private _envanter: Envanter ={};
    public get envanter(): Envanter {
        return this._envanter;
    }
    public set envanter(v: Envanter) {
        this._envanter = v;
    }

    public selectedCompany: number;
    public companyList: Array<Company>;


    constructor(
        @Inject(MAT_DIALOG_DATA) private _data: any,
        private _toasterService: ToasterService,
        private _companyService: CompanyService,
        private _envanterService: EnvanterService,
        private _translateService:TranslateService,
        private _dialogRef: MatDialogRef<EnvanterFormComponent>) {
        super();
    }


    public async ngOnInit(): Promise<void> {

        this.companyId=parseInt(localStorage.getItem("CompanyID"));
        try {

            if (parseInt(localStorage.getItem("CompanyID"))== 1) {
                this.companyList = await this._companyService.getCompanies();
            }
        } catch (error) {
            console.warn(error);
        }
    }


    public async save(form:NgForm): Promise<void> {
        if (form.form.invalid) {
            this._toasterService.toastWarning(this._translateService.instant("PLEASE_FILL_IN_THE_FORM_CORRECTLY"))
            return
        }
        if (this.fileData.length == 0) {
            this._toasterService.toastWarning(this._translateService.instant("FILE_NOT_SELECTED"))
            return;
        }
        this.envanter.latitude=this._data.lat;
        this.envanter.longitude=this._data.lng;
        this.envanter.status=true;
        this.envanter.companyId = parseInt(localStorage.getItem("CompanyID")) == 1 ? this.selectedCompany :parseInt(localStorage.getItem("CompanyID"))
        const formData = new FormData();
        formData.append("files", this.fileData[0])
        try {
            let uresponse = await this._envanterService.upload(formData)
            this.envanter.icon = uresponse.toString();
            if (uresponse[0] != null) {
                await this._envanterService.add(this.envanter);
                this.added.emit(true);
            }
            else{
            this.added.emit(false);
            }
            this._dialogRef.close();
        } catch (ex) {
            this.added.emit(false);
        }
    }

    public fileChange(f) {
        try {
            this.fileData.push(f[0])
        } catch (error) {
            console.warn(error);
        }
    }

}
